import { DateTime } from "./luxon.js";

export function getValueForTimeInput(value: Date | string): string {
	const date = value instanceof Date ? value : new Date(value);
	return DateTime.fromJSDate(date).toFormat("HH:mm");
}
